export default "__VITE_ASSET__FhLmsNgA__"